module.exports = __webpack_public_path__ + "img/regulation_network.cb389ebc.svg";